import { Link, useLocation } from "react-router-dom";
import { Radar, Activity, Mail } from "lucide-react";
import UserMenu from "@/components/UserMenu";
import UsageBadge from "@/components/UsageBadge";
import DigestDialog from "@/components/DigestDialog";
import { useAuth } from "@/contexts/AuthContext";
import { useState } from "react";

export const AppHeader = ({ rightSlot }) => {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const [digestOpen, setDigestOpen] = useState(false);
  const isManager = (user?.role || "bdr") === "manager";

  const navItems = [
    { to: "/", label: "Intelligence", match: (p) => p === "/" || p.startsWith("/report/") },
    { to: "/pipeline", label: "Pipeline", match: (p) => p.startsWith("/pipeline") },
    ...(isManager ? [{ to: "/team", label: "Team", match: (p) => p.startsWith("/team") }] : []),
  ];
  return (
    <header className="sticky top-0 z-40 w-full bg-[#0A0A0A]/85 backdrop-blur-xl border-b border-[#262626] no-print">
      <div className="flex items-center justify-between h-14 px-6 md:px-8">
        <div className="flex items-center gap-8">
          <Link to="/" className="flex items-center gap-3 group" data-testid="header-home-link">
            <div className="relative w-7 h-7 flex items-center justify-center rounded-sm border border-[#262626] bg-[#141414]">
              <Radar className="w-4 h-4 text-[#0A84FF]" strokeWidth={1.6} />
              <span className="absolute inset-0 rounded-sm ring-1 ring-[#0A84FF]/20 animate-pulse" />
            </div>
            <div className="flex items-baseline gap-2">
              <span className="font-display font-semibold text-[15px] tracking-tight text-white">RADAR</span>
              <span className="kpi-label hidden sm:inline">Account Intelligence</span>
            </div>
          </Link>
          <nav className="hidden md:flex items-center gap-1" data-testid="main-nav">
            {navItems.map((n) => {
              const active = n.match(pathname);
              return (
                <Link
                  key={n.to}
                  to={n.to}
                  data-testid={`nav-${n.label.toLowerCase()}`}
                  className={`px-3 py-1.5 rounded-sm text-xs font-mono-data tracking-wider uppercase transition-colors ${
                    active
                      ? "bg-[#1F1F1F] text-white border border-[#262626]"
                      : "text-[#737373] hover:text-white border border-transparent"
                  }`}
                >
                  {n.label}
                </Link>
              );
            })}
          </nav>
        </div>
        <div className="flex items-center gap-2">
          {user && <UsageBadge />}
          <div className="hidden lg:flex items-center gap-2 kpi-label mr-2">
            <Activity className="w-3 h-3 text-[#32D74B]" />
            <span>Engine · v1.0</span>
          </div>
          {user && (
            <button
              type="button"
              onClick={() => setDigestOpen(true)}
              data-testid="digest-trigger-btn"
              className="h-9 px-3 rounded-sm border border-[#262626] hover:border-[#404040] bg-[#141414] hover:bg-[#1F1F1F] flex items-center gap-2 transition-colors"
              title="Weekly digest"
            >
              <Mail className="w-3.5 h-3.5 text-[#0A84FF]" strokeWidth={1.7}/>
              <span className="hidden md:inline text-xs font-mono-data tracking-wider uppercase text-white">Digest</span>
            </button>
          )}
          {rightSlot}
          <UserMenu />
        </div>
      </div>
      <DigestDialog open={digestOpen} onOpenChange={setDigestOpen}/>
    </header>
  );
};

export default AppHeader;
